import { render, staticRenderFns } from "./RequestTabsView.vue?vue&type=template&id=1f6009f0&scoped=true&"
import script from "./RequestTabsView.vue?vue&type=script&lang=ts&"
export * from "./RequestTabsView.vue?vue&type=script&lang=ts&"
import style0 from "./RequestTabsView.vue?vue&type=style&index=0&id=1f6009f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6009f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f6009f0')) {
      api.createRecord('1f6009f0', component.options)
    } else {
      api.reload('1f6009f0', component.options)
    }
    module.hot.accept("./RequestTabsView.vue?vue&type=template&id=1f6009f0&scoped=true&", function () {
      api.rerender('1f6009f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "landing/src/views/admin/request/RequestTabsView.vue"
export default component.exports